import type { LinkProps } from "@chakra-ui/react"
import { Link } from "@chakra-ui/react"
import NextLink from "next/link"

const TextLink = ({ children, ...props }: LinkProps) => {
  return (
    <Link
      as={NextLink}
      color={"brand.800"}
      textDecoration={"underline"}
      _hover={{
        textDecoration: "none",
        color: "brand.500",
      }}
      {...props}
    >
      {children}
    </Link>
  )
}

export default TextLink
